import React from "react";

import flattenChildren from "react-keyed-flatten-children";

import {
  makeDimensionNegative,
  ResponsiveDimension
} from "../../../styles/dimensions/dimensions";
import {
  AlignItems,
  Flex,
  FlexWrap,
  JustifyContent,
  ResponsiveProp
} from "../../../types";
import Box from "../Box";

type Props = {
  children: React.ReactNode;
  space?: ResponsiveDimension;
  justifyContent?: ResponsiveProp<JustifyContent>;
  alignItems?: ResponsiveProp<AlignItems>;
  flexWrap?: ResponsiveProp<FlexWrap>;
  flexValues?: Flex[];
};

export default function Inline({
  children,
  space,
  justifyContent = "flex-start",
  alignItems,
  flexWrap = "wrap",
  flexValues
}: Props) {
  if (flexValues && flexValues.length !== React.Children.count(children)) {
    throw new Error("You must provide a flex value for each child");
  }

  return (
    <Box
      marginLeft={makeDimensionNegative(space)}
      marginTop={makeDimensionNegative(space)}
      display="flex"
      justifyContent={justifyContent}
      flexWrap={flexWrap}
      alignItems={alignItems}
    >
      {React.Children.map(flattenChildren(children), (child, index) => (
        <Box
          key={index}
          paddingLeft={space}
          paddingTop={space}
          flex={flexValues ? flexValues[index] : undefined}
        >
          {child}
        </Box>
      ))}
    </Box>
  );
}
